import BatchQuoteDetails from "../../../components/Dashboard/BatchQuoteDetails";
import "./style.scss";

const BatchQuoteDetailsPage = () => {
  return (
    <div className="batch_quote_details_page_wrapper">
      <BatchQuoteDetails />
    </div>
  );
};
export default BatchQuoteDetailsPage;
